import {
  Container,
  DefaultPageLayout,
  HeadMetatags,
} from 'routes/components/Layout'
import { UniversalConnectorsHero } from './components/Hero'
import { DiscoverStructure } from './components/DiscoverStructure'
import { MostExtensiveFramework } from './components/MostExtensiveFramework'
import { MappedByAI } from './components/MappedByAI'
import classes from './UniversalConnectors.module.scss'

export default function UniversalConnectorsPage() {
  return (
    <DefaultPageLayout className={classes.page}>
      <HeadMetatags title={'Universal Connectors'} />
      <Container grid>
        <UniversalConnectorsHero />
        <DiscoverStructure />
        <MostExtensiveFramework />
        <MappedByAI />
      </Container>
    </DefaultPageLayout>
  )
}
